import React from 'react';
import styles from './CallToAction.module.scss';

export const CallToAction: React.FC = () => {
    return (
        <section className={styles.ctaContainer}>
            {/* Слой с паттерном */}
            <div className={styles.patternOverlay}></div>

            {/* Контентная часть */}
            <div className={styles.content}>
                <h2 className={styles.title}>Закажите обработку вашей квартиры</h2>
                <button className={styles.button}>Оставить заявку</button>
            </div>
        </section>
    );
};